import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes as RoutePath } from "react-router-dom";

import LoginPage from "./pages/auth/LoginPage";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import TermsConditions from "./pages/TermsConditions";

import PricingPage from "./pages/home/pricing";

// Root Layout
import RootLayout from "./pages/home/rootLayout";

// Imports
import OrderPage from "./pages/home/orders/order";
import OrdersManagementPage from "./pages/home/orders/management";
import DriversPage from "./pages/home/drivers";

const Routes = () => {
  const { token } = useSelector(({ auth }) => auth);

  return (
    <RoutePath>
      {!token && <Route path="/login" element={<LoginPage />} />}

      <Route element={<RootLayout />}>
        <Route path="orders" element={<OrdersManagementPage />} />
        <Route path="orders/:id" element={<OrderPage />} />
        <Route path="drivers" element={<DriversPage />} />
        <Route path="pricings" element={<PricingPage />} />
      </Route>

      <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
      <Route path="/termsConditions" element={<TermsConditions />} />
      <Route path="/forgotpassword" element={<ForgotPassword />} />
      <Route path="/cookiePolicy" element={<CookiePolicy />} />
      <Route path="/resetpassword/:token" element={<ResetPassword />} />

      {/* Catch All Route */}
      <Route
        path="*"
        element={token ? <Navigate to="orders" /> : <Navigate to="login" />}
      />
    </RoutePath>
  );
};

export default Routes;
